import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type FetchEnabledOptimizationsDto = ClientInferResponseBody<
  typeof contract.optimizations.listEnabled
>;

export type EnabledOptimizationDto = FetchEnabledOptimizationsDto["optimizations"][number];

export const fetchEnabledOptimizations = async (
  quoteRequestId: string,
): Promise<EnabledOptimizationDto[]> => {
  const response = await api.optimizations.listEnabled.query({
    query: { quoteRequestId },
  });

  if (response.status !== 200) {
    throw new ApiError("Error fetching enabled optimizations", response.status, response.body);
  }

  return response.body.optimizations;
};
